import React from "react";
import { Link, Typography } from "@mui/material";

const links = [
  {
    url: "https://www.janfoote.com/",
    text: "Jan Foote",
  },
  {
    url: "https://jackquartet.com/",
    text: "JACK Quartet",
  },
  {
    url: "https://robertoalonsotrillo.com/",
    text: "Roberto Alonso Trillo",
  },
  {
    url: "https://www.fonotecanacional.gob.mx/",
    text: "Fonoteca Nacional",
  },
  {
    url: "https://fondspodiumkunsten.nl/nl/actueel/producties/echoes_of_joni/",
    text: "Fondspodiumkunsten NL",
  },
  {
    url: "https://www.yarnwire.org/",
    text: "Yarn/Wire",
  },
  {
    url: "https://www.as-coa.org/",
    text: "AS/COA",
  },
];

// eslint-disable-next-line
export default {
  title: "Events",
  upcoming: "Upcoming",
  data: [
    {
      date: "2021/12/15",
      name: (
        <Typography variant="body2">
          Premiere of "Echoes of Joni" by composer{" "}
          <Link variant="body2" href={links[0].url}>
            {links[0].text}
          </Link>{" "}
          with Attica! ensemble at PLUG Festival Online
        </Typography>
      ),
      location: "Glasgow, Scotland",
    },
    {
      date: "2021/12/15",
      name: (
        <Typography variant="body2">
          Workshop with the{" "}
          <Link variant="body2" href={links[1].url}>
            {links[1].text}
          </Link>{" "}
          as part of their program Jack Studio
        </Typography>
      ),
      location: "Brooklyn, NY",
    },
    {
      date: "2021/12/15",
      name: (
        <Typography variant="body2">
          Premiere of "Como un reposado vacío" for violin and live electronics
          performed by{" "}
          <Link variant="body2" href={links[2].url}>
            {links[2].text}
          </Link>
        </Typography>
      ),
      location: "Lugo, Spain",
    },
    {
      date: "2021/11/15",
      name: (
        <Typography variant="body2">
          Recording of "Echoes of Joni" by composer{" "}
          <Link variant="body2" href={links[0].url}>
            {links[0].text}
          </Link>{" "}
          with Attica! ensemble at{" "}
          <Link variant="body2" href={links[3].url}>
            {links[3].text}
          </Link>{" "}
          and One Love Studios
        </Typography>
      ),
      comments: (
        <Typography variant="caption" sx={{ fontStyle: "italic" }}>
          Project supported by{" "}
          <Link
            variant="caption"
            sx={{ fontStyle: "italic" }}
            href={links[4].url}
          >
            {links[4].text}
          </Link>
          , Help Musicians UK and The Royal Conservatoire of Scotland
        </Typography>
      ),
      location: "Mexico City, Mexico",
    },
    {
      date: "2021/11/15",
      name: (
        <Typography variant="body2">
          Performance of "Como hilos de viento y luz" for VHS magnetic tapes by{" "}
          <Link variant="body2" href={links[5].url}>
            {links[5].text}
          </Link>{" "}
          with Jeffrey Gavett at{" "}
          <Link variant="body2" href={links[6].url}>
            {links[6].text}
          </Link>
        </Typography>
      ),
      location: "Americas Society, New York, NY",
    },
  ],
};
